import {SiteConfigContextValue} from './site-config-context';
export const BaseSiteConfig: SiteConfigContextValue = {
  auth: {
    redirectUri: '/',
    adminRedirectUri: '/admin',
  },
  tags: {
    types: [{name: 'custom'}],
  },
  customPages: {
    types: [{type: 'default', label: 'Default'}],
  },
  admin: {
    ads: [],
  },
  demo: {
    loginPageDefaults: 'singleAccount',
  },
  homepage: {
    options: [
      {label: 'Login page', value: 'loginPage'},
      {label:'Registration page', value: 'registerPage'},
    ],
  },
};
